import { Link } from "react-router-dom";
import { mediaList } from "@/mocks/media";
import { newsList } from "@/mocks/news";

const tiles = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    label: "日韩电影",
    en: "Movies",
    desc: "院线新片 · 影展佳作",
    count: mediaList.filter((item) => item.type === "movie").length,
    unit: "部",
    dark: false,
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    label: "日韩电视剧",
    en: "TV Series",
    desc: "当季新剧 · 口碑短剧",
    count: mediaList.filter((item) => item.type === "tv").length,
    unit: "部",
    dark: false,
  },
  {
    to: "/category/variety",
    icon: "ri-mic-line",
    label: "日韩综艺",
    en: "Variety",
    desc: "治愈慢综 · 美食纪实",
    count: mediaList.filter((item) => item.type === "variety").length,
    unit: "部",
    dark: false,
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    label: "影视资讯",
    en: "News",
    desc: "新片动态 · 行业观察",
    count: newsList.length,
    unit: "篇",
    dark: true,
  },
];

export default function CategoryQuickLinks() {
  return (
    <div className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4">
      {tiles.map((tile) => (
        <Link
          key={tile.to}
          to={tile.to}
          className={`group relative flex cursor-pointer flex-col rounded-lg border p-4 transition-colors md:p-5 ${
            tile.dark
              ? "border-primary-900 bg-primary-950 text-background-50 hover:border-accent-500/60"
              : "border-background-200/80 bg-background-50 hover:border-primary-300"
          }`}
        >
          <div className="flex items-start justify-between">
            <span
              className={`flex h-10 w-10 items-center justify-center rounded-md ${
                tile.dark ? "bg-background-50/10 text-accent-300" : "bg-primary-50 text-primary-700"
              }`}
            >
              <i className={`${tile.icon} text-xl`} />
            </span>
            <span
              className={`font-label text-[11px] ${tile.dark ? "text-background-400" : "text-foreground-400"}`}
            >
              {String(tile.count).padStart(2, "0")} {tile.unit}
            </span>
          </div>
          <p
            className={`mt-4 text-sm font-medium ${tile.dark ? "text-background-50" : "text-foreground-950"}`}
          >
            {tile.label}
          </p>
          <p className={`mt-1 text-xs ${tile.dark ? "text-background-300" : "text-foreground-500"}`}>
            {tile.desc}
          </p>
          <div className="mt-3 flex items-center justify-between">
            <span
              className={`font-label text-[10px] uppercase tracking-[0.18em] ${
                tile.dark ? "text-background-400" : "text-foreground-400"
              }`}
            >
              {tile.en}
            </span>
            <i
              className={`ri-arrow-right-up-line text-base transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 ${
                tile.dark ? "text-accent-400" : "text-primary-600"
              }`}
            />
          </div>
        </Link>
      ))}
    </div>
  );
}